import {post} from '../index'
export default {
  // 添加新客福包
  cashActiveAdd (querys) {
    return post('/redbag/admin/AdminActive/activeAdd', querys)
  },
  // 回显新客福包
  cashActiveInfo (querys) {
    return post('/redbag/admin/AdminActive/activeInfo', querys)
  },
  // 新客福包列表
  cashActiveList (querys) {
    return post('/redbag/admin/AdminActive/activeList', querys)
  },
  // 新客福包列表
  cashDefaultSetting (querys) {
    return post('/redbag/admin/AdminActive/defaultSetting', querys)
  },
  // 添加图片
  cashImgAdd (querys) {
    return post('/redbag/admin/AdminImg/imgAdd', querys)
  },
  // 回显 编辑 删除图片
  cashImgUpdate (querys) {
    return post('/redbag/admin/AdminImg/imgUpdate', querys)
  },
  // 图片列表
  cashImgList (querys) {
    return post('/redbag/admin/AdminImg/imgList', querys)
  },
  // 发放记录
  cashStaffRecordList (querys) {
    return post('/redbag/admin/AdminRecord/staffRecordList', querys)
  },
  // 停止发放
  cashStopRecord (querys) {
    return post('/redbag/admin/AdminRecord/stopRecord', querys)
  },
  // 发放记录-已领取客户
  cashRecordList (querys) {
    return post('/redbag/admin/AdminRecord/recordInfoList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/cash.js